/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 100%;
  max-width: 315px;
  height: 100vh;

  img {
    width: 50%;
  }

  form {
    display: flex;
    flex-direction: column;
    margin-top: 30px;

    input {
      background: rgba(0, 0, 0, 0);
      border: 1px solid #36ded6;
      border-radius: 5px;
      box-sizing: border-box;
      height: 50px;
      padding: 0 15px;
      color: #fff;
      margin: 0 0 14px;

      &::placeholder {
        color: #fff;
      }
    }

    button {
      margin: 5px 0 0;
      height: 50px;
      background: #36ded6;
      font-weight: bold;
      color: #090f35;
      border: 0;
      border-radius: 5px;
      font-size: 14px;
      transition: background 0.2s;

      &:hover {
        background: ${darken(0.08, '#36ded6')};
      }
    }

    a {
      color: #36ded6;
      margin-bottom: 25px;
      font-size: 14px;
      font-weight: bold;
      opacity: 0.8;

      &:hover {
        opacity: 1;
      }
    }
  }

  p {
    color: #fff;
    font-size: 18px;
  }
`;
